//色块列表
export const colorArr = [
  "#2EC5C7",
  "#9559F5",
  "#FA7C7D",
  "#61CC7A",
  "#2EC5C7",
  "#9559F5",
  "#FA7C7D",
  "#61CC7A",
  "#F56B56",
  "#4184F5",
  "#7583FF",
  "#FC5886",
  "#F56B56",
  "#4184F5",
  "#7583FF",
];
//教材背景图列表
export const bookBgList = [
  "icon-fengmian",
  "icon-fengmian1",
  "icon-fengmian2",
  "icon-fengmian3",
  "icon-fengmian4",
  "icon-fengmian5",
  "icon-fengmian6",
  "icon-fengmian7",
];
//文件类型图标列表
export const fileTypeList = {
  1102: "icon-doc-word",
  1103: "icon-doc-ppt",
  1104: "icon-doc-pdf",
  1105: "icon-doc-compress",
  1106: "icon-doc-mp3",
  1107: "icon-doc-video",
};

//文件临时类型图标列表
export const fileTempTypeList = {
  1102: "doc",
  1103: "ppt",
  1104: "pdf",
  1105: "rar",
  1106: "mp3",
};
// 下载期限排序
export const downloadOrders = [
  // {
  //   name: "不限",
  //   strNodeId: null,
  // },
  {
    name: "总下载",
    strNodeId: "downloads",
  },
  {
    name: "日下载",
    strNodeId: "day_downloads",
  },
  {
    name: "周下载",
    strNodeId: "week_downloads",
  },
  {
    name: "月下载",
    strNodeId: "month_downloads",
  },
];
// 默认头像
export const defaultFaceImg =
  "//zxxkstatic.zxxk.com/uc/images/userface/00001.jpg";
